/*
 * @Author: wzh
 * @LastEditTime: 2024-11-29 15:22:11
 * @Description: 完善资料 等 公共方法
 */

import * as CryptoJS from "crypto-js"; // base64解密
import { mapGetters } from "vuex";

export const commonMethods = {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("auth", ["user", "token"]),
  },
  methods: {
    getCookieDomain() {
      const host = window.location.hostname || "";
      const isIpv4 = /^(\d{1,3}\.){3}\d{1,3}$/.test(host);
      if (!host || host === "localhost" || isIpv4 || host.indexOf(".") === -1) {
        return "";
      }
      const parts = host.split(".");
      if (parts.length <= 2) {
        return `.${host}`;
      }
      return `.${parts.slice(-2).join(".")}`;
    },
    setLoginCookies(token, user) {
      if (!token) return;
      const rememberMe = this.$cookies.get("REMEMBER_ME");
      const rememberMeToken = rememberMe && rememberMe.token;
      const isRememberMe = rememberMeToken && rememberMeToken === token;
      const domain = this.getCookieDomain();
      const domainPart = domain ? `; domain=${domain}` : "";
      // 先清理 host/domain 下历史同名 cookie，避免出现两个 congress
      document.cookie = `congress=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      if (domain) {
        document.cookie = `congress=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      }
      const maxAgePart = isRememberMe ? `; max-age=${7 * 24 * 60 * 60}` : "";
      document.cookie = `congress=${encodeURIComponent(
        token
      )}; path=/${domainPart}${maxAgePart}; SameSite=Lax`;
      document.cookie = `token=${encodeURIComponent(token)}; path=/${domainPart}; SameSite=Lax`;
      const encodedUser = encodeURIComponent(JSON.stringify(user || {}));
      document.cookie = `user=${encodedUser}; path=/${domainPart}; SameSite=Lax`;
    },
    // base64解码
    // getBase64(redirect_uri) {
    // 	let url = CryptoJS.enc.Base64url.parse(redirect_uri).toString(
    // 		CryptoJS.enc.Utf8
    // 	);
    // 	return window.decodeURIComponent(url);
    // },
    getBase64(base64) {
      try {
        // 20240316 panmy 原始的atoh 无效 需要个性化
        // const decodedBase64Url = decodeURIComponent(base64);
        const base64UrlDecode = (cipher) => {
          // 将字符 '-' 替换为 '+'
          var s = cipher.replace(/-/g, "+");
          // 将字符 '_' 替换为 '/'
          s = s.replace(/_/g, "/");
          // 检查末尾的 '=' 字符数量
          switch (s.length % 4) {
            case 0:
              break; // 不需要填充
            case 2:
              s += "==";
              break; // 两个填充字符
            case 3:
              s += "=";
              break; // 一个填充字符
            default:
              console.error("Illegal base64url String!");
              return null; // 非法的 Base64URL 字符串
          }
          // 使用 window.atob() 进行 Base64 解码
          var decoded = atob(s);
          // 将解码后的字符串转换为字节数组
          // var bytes = new Uint8Array(decoded.length);
          // for (var i = 0; i < decoded.length; i++) {
          //   bytes[i] = decoded.charCodeAt(i);
          // }
          return decoded;
        };
        const url = base64UrlDecode(decodeURIComponent(base64));
        return url;
      } catch (error) {
        // 错误处理
        console.error(
          "An error occurred during Base64 to URL decoding:",
          error
        );
        return null;
      }
    },

    // 返回登录
    goLogin() {
      this.$store.dispatch("auth/loginOut");
    },
    // 判断下一步操作
    jumpComputed() {
      let redirect_uri = sessionStorage.getItem("REDIRECT_URI");
      let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
      // 判断账户是否处于休眠状态
      if (before_login.isSleep) {
        this.$router.replace({ path: "/unsleep" });
      } else if (before_login.noSingleLogin) {
        this.$router.replace({ path: "/simplyLogin" });
      } else if ("1,2,3".includes(before_login.editPwd)) {
        this.$router.replace({ path: "/updatePassword" });
      } else if (before_login.showInfo) {
        this.$router.replace({ path: "/perfectInfo" });
      } else if (before_login.userInfoConfim) {
        this.$router.replace({ path: "/forgotten" });
      } else if (before_login.secAuth) {
        this.$router.replace({ path: "/secondAuth" });
      } else {
        this.$store.commit("auth/setSessionToken", this.token);
        this.$store.commit("auth/setSessionUser", this.user);
        sessionStorage.removeItem("BEFORE_LOGIN");
        this.setLoginCookies(this.token, this.user);
        // this.$cookies.set("token", this.token, {domain: '.lzjczl.com'});
        if (redirect_uri) {
          let url = this.getBase64(redirect_uri);
          location.href = url; // + "?haslogin=true";
          // window.open(url)
        } else {
          this.$router.replace({ path: "/authserver" });
        }
      }
    },
  },
};
